export default __webpack_public_path__ + "static/media/AvertaDemoPE-Regular.dde3fb23.otf";